import { useCallback } from "react";
import { useAsync } from "@perxis-auto/shared";
import isEqual from "lodash.isequal";
import "../../internal/features/forms/middleware.js";
import { formsActions } from "../../internal/features/forms/reducer.js";
import { selectFieldValueById, selectFieldIsMissingDependentFieldValuesById, selectDependFieldValuesByFieldId } from "../../internal/features/forms/selectors.js";
import "../../internal/features/stages/middleware.js";
import "../../internal/features/stages/reducer.js";
import { selectFieldById } from "../../internal/features/stages/selectors.js";
import { useAppActions } from "../../internal/shared/lib/store/hooks/useAppActions.js";
import { useAppDispatch } from "../../internal/shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../internal/shared/lib/store/hooks/useAppSelector.js";
function useField({ id, formId }) {
  const dispatch = useAppDispatch();
  const field = useAppSelector((state) => selectFieldById(state, { fieldId: id, formId }));
  const value = useAppSelector((state) => selectFieldValueById(state, { fieldId: id, formId }), {
    equalityFn: isEqual
  });
  const isMissingDependentFieldValues = useAppSelector(
    (state) => selectFieldIsMissingDependentFieldValuesById(state, { fieldId: id, formId })
  );
  const dependFieldValues = useAppSelector(
    (state) => selectDependFieldValuesByFieldId(state, { fieldId: id, formId }),
    {
      equalityFn: isEqual
    }
  );
  const {
    forms: { setValue }
  } = useAppActions();
  const setFieldValue = useCallback(
    (value2) => {
      setValue({ formId, id, value: value2 });
    },
    [formId, id, setValue]
  );
  const fetchOptions = useCallback(() => {
    return dispatch(formsActions.getOptions({ formId, fieldId: id })).unwrap();
  }, [dispatch, formId, id]);
  const [fieldCatalog, loading, error, getOptions] = useAsync(fetchOptions, {}, [
    id,
    formId,
    dependFieldValues
  ]);
  return {
    data: field,
    options: fieldCatalog == null ? void 0 : fieldCatalog.values,
    value,
    disabled: isMissingDependentFieldValues,
    loading,
    error,
    actions: {
      setFieldValue,
      getOptions
    }
  };
}
export {
  useField
};
